import { bffApi } from "../../../autogen/bff-api";
import { useApiError } from "../../errors/useApiError";
import { useAppDispatch } from "../../redux/hooks";

export const useDocumentDownloader = () => {
  const dispatch = useAppDispatch();
  const displayer = useApiError();

  const downloadSignedDocument = async (documentId: string): Promise<string | null> => {
    const postRequestResult = await dispatch(
      bffApi.endpoints.getSignedDocumentDownloadLink.initiate({
        docId: documentId,
      })
    )
      .unwrap()
      .catch((e) => {
        displayer.trigger(e);
        throw e;
      });
    return postRequestResult.url;
  };

  const downloadDocument = async (documentId: string): Promise<string> => {
    const postRequestResult = await dispatch(
      bffApi.endpoints.getDownloadLink.initiate({
        docId: documentId,
      })
    )
      .unwrap()
      .catch((e) => {
        displayer.trigger(e);
        throw e;
      });
    return postRequestResult.url;
  };

  const getDownloadLink = async (documentId: string, isSignedDocument: boolean): Promise<string | null> => {
    if (isSignedDocument) {
      return await downloadSignedDocument(documentId);
    } else {
      return await downloadDocument(documentId);
    }
  };

  // Q&A attachments are authorized per sourcing event (thread membership), so they use a dedicated
  // event-scoped endpoint rather than the generic document download link.
  const getSeV2AttachmentDownloadLink = async (eventId: string, documentId: string): Promise<string | null> => {
    const result = await dispatch(bffApi.endpoints.getSeV2AttachmentDownloadLink.initiate({ eventId, documentId }))
      .unwrap()
      .catch((e) => {
        displayer.trigger(e);
        throw e;
      });
    return result.url;
  };

  return {
    getDownloadLink,
    getSeV2AttachmentDownloadLink,
  };
};
